import { render, staticRenderFns } from "./SocialInbox.vue?vue&type=template&id=a68e5c8a&scoped=true&"
import script from "./SocialInbox.vue?vue&type=script&lang=js&"
export * from "./SocialInbox.vue?vue&type=script&lang=js&"
import style0 from "./SocialInbox.vue?vue&type=style&index=0&id=a68e5c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68e5c8a",
  null
  
)

export default component.exports